import React from 'react';
import './Page.css';

const PrivacyPolicy = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h1>Privacy Policy</h1>
        
        <p>This privacy policy is part of, and should be read in conjunction with, the Quantum Sync terms and conditions and cookie policy notice. It explains how we may collect, create, process, store, protect, disclose, share, and transfer your Personal Data as part of providing our services or as part of our business operations.</p>
        
        <p><strong>"Personal Data"</strong> refers to any information that can identify or reasonably identify an individual, directly or indirectly, such as a name, identification number, or online identifier.</p>
        
        <h2>Collection of Personal Data</h2>
        <p>We collect Personal Data when provided to us (e.g., when you contact us), during interactions with you (e.g., when you make a purchase), when you make your Personal Data public (e.g., social media posts), when you visit our sites, or when you register to use our services.</p>
        
        <h2>How We Use Your Data</h2>
        <p>We process Personal Data for various purposes, including:</p>
        
        <div className="info-cards">
          <div className="info-card">
            <h3>Providing Services</h3>
            <p>Delivering our cryptocurrency trading and exchange services to you.</p>
          </div>
          
          <div className="info-card">
            <h3>Legal Compliance</h3>
            <p>Fulfilling legal and compliance obligations, including KYC and AML requirements.</p>
          </div>
          
          <div className="info-card">
            <h3>Business Operations</h3>
            <p>Operating our business efficiently and improving our services.</p>
          </div>
          
          <div className="info-card">
            <h3>IT Systems Management</h3>
            <p>Managing and maintaining our IT infrastructure and security.</p>
          </div>
          
          <div className="info-card">
            <h3>Security & Fraud Prevention</h3>
            <p>Ensuring security and preventing fraudulent activities on our platform.</p>
          </div>
        </div>
        
        <h2>Data Protection</h2>
        <p>We implement appropriate technical and organizational measures to protect your Personal Data against unauthorized access, alteration, disclosure, or destruction.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
